import axios from "axios";
import routes from "../../configs/api";

const forgetPassword = (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.FORGET_PASSWORD;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default forgetPassword;
